<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" >
                <el-form-item label="学生名称">
                    <el-input v-model="attr.examResult.userName" disabled></el-input>
                </el-form-item>
                <el-form-item label="考试">
                    <el-input v-model="attr.examResult.examName" disabled></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    min-width="180"
                    prop="typeName"
                    label="类型" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="questionFormHtml"
                    label="题目" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="answer"
                    label="正确答案" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="myAnswer"
                    label="我的答案" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                     prop="score"
                    label="对or错" >
                    <template slot-scope="scope">
                        <div class="fx-col fx-center" style="color:green" v-if="scope.row.result && scope.row.type!=4">
                              √
                        </div>
                        <div class="fx-col fx-center" style="color:red" v-if="!scope.row.result && scope.row.type!=4">
                              ×
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="questionScore"
                    label="题目满分" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="score"
                    label="考试得分" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="remark"
                    label="批注" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="operatorName"
                    label="阅卷人" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="markingTime"
                    label="批改时间" >
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>
    </div>
</template>

<style scoped>

</style>

<script>

    import {mapMutations} from 'vuex';
    export default {
        components: {
        },
        props: [
            "attr"
        ],
        data() {
            return {
                form: {
                    keywords: "",
                },
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                tableData: [],
                examResult:{...this.attr.examResult},
            }
        },
        watch: {
            "form": {
                handler: function (newValue) {
                    this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true
            }
        },
        methods: {
            ...mapMutations(["openTab"]),
            loadData() {
                this.$ajaxPost("/examAnswer/getExamAnswerByMarker", {
                    examResult: this.examResult,
                    pager: {...this.pager, dataTotal: 0}
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    this.tableData = data.result;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },
        },
        created() {
            this.loadData();
        }
    }
</script>
